<ng-template #selectorContent>
  <app-group-selector
    [groupFilters]="groupFilters"
    [presentation]="'row'"
    [showAddCustomer]="showAddCustomer"
    (selectedGroup)="selectGroup($event)"
    class="block min-h-0 flex-1"
  ></app-group-selector>

  @if (showRemoveParent) {
    <div
      class="flex shrink-0 items-center justify-end gap-2 border-t border-grey-concrete bg-white p-3 text-sm text-grey-blue shadow-md"
    >
      <button class="btn-danger-secondary btn-xs text-sm" type="button" (click)="removeSelectedParent()">
        Remove Parent
      </button>
    </div>
  }
</ng-template>

@if (presentation === 'modal') {
  <div class="flex h-full min-h-0 flex-col">
    <app-header [title]="title">
      <button
        additional-slot
        id="close-modal-button"
        class="btn-primary m-0 flex w-min items-center justify-center p-1"
        (click)="close()"
      >
        <ion-icon class="h-5 w-5" name="close-outline"></ion-icon>
      </button>
    </app-header>

    <div class="flex min-h-0 flex-1 flex-col">
      <ng-container [ngTemplateOutlet]="selectorContent"></ng-container>
    </div>
  </div>
} @else {
  <ion-popover
    #popover
    [keepContentsMounted]="false"
    [dismissOnSelect]="false"
    size="auto"
    mode="md"
    class="[--max-width:calc(100vw_-_1rem)] [--width:420px]"
  >
    <ng-template>
      <div class="flex w-full h-[min(70vh,420px)] min-h-0 flex-col overflow-hidden bg-white">
        <div class="border-b border-grey-concrete px-3 py-2">
          <div class="text-base font-medium text-grey-blue">{{ title }}</div>
        </div>
        <ng-container [ngTemplateOutlet]="selectorContent"></ng-container>
      </div>
    </ng-template>
  </ion-popover>
}
